import { GET_TRAIN_FAULTS } from './types';

export function getAllTrainFaults(payload) {
  return {
    type: GET_TRAIN_FAULTS,
    payload
  }
}